import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  title = input.required<string>();
  message = input.required<string>();
  confirmText = input<string>('Confirm');
  cancelText = input<string>('Cancel');
  confirmClass = input<string>('bg-blue-600 hover:bg-blue-700');
  confirmDisabled = input<boolean>(false);
  cancelDisabled = input<boolean>(false);
  isSubmitting = input<boolean>(false);

  close = output<void>();
  confirm = output<void>();
}
